import { BaSeLoading } from '@base/react';
import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';

interface RedirectPageProps {
  route: string;
}

const RedirectPage: React.FC<RedirectPageProps> = ({ route }) => {
  const { navigateTo } = Sebrae.useRouter();
  const { isAuthenticated, login } = Sebrae.useAuth();

  React.useEffect(() => {
    if (!isAuthenticated) {
      login();
      return;
    }
    navigateTo(route);
  }, [isAuthenticated, route, login, navigateTo]);

  return <BaSeLoading text="Carregando…" />;
};

export { RedirectPage as default };
